/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for redux-saga es6 generator support
import "babel-polyfill";

// Import all the third party stuff
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import App from "./containers/App";
import { API_URL } from "./utils/axios";
import createEmotionCache from "./utils/createEmotionCache";
import { CacheProvider } from "@emotion/react";

// Import Language Provider
import { LanguageProvider } from "./containers/LanguageProvider";

import configureStore from "./store/index";

// Import i18n messages
import { translationMessages } from "./i18n";

import "react-datepicker/dist/react-datepicker.css";
import "react-quill/dist/quill.snow.css";
import "./main.scss";
import "./global.scss";
import "./components/input/styles.scss";
//import * as eruda from "eruda";
//eruda.init();
const initialState = {};
const { persistor, store } = configureStore(initialState);
const MOUNT_NODE = document.getElementById("root");
const cache = createEmotionCache();

const state = store.getState();

const { EventEmitter } = require("fbemitter");
window.eventEmitter = new EventEmitter();

const render = messages => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages} locale={state.language.locale}>
        <PersistGate persistor={persistor}>
        <CacheProvider value={cache}>
            <App />
          </CacheProvider>
        </PersistGate>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  );
};

const originalInsertBefore = Node.prototype.insertBefore;

Node.prototype.insertBefore = function(newNode, referenceNode) {
  if (
    newNode.tagName === "SCRIPT" &&
    newNode.type === "text/javascript" &&
    !newNode.src
  ) {
    newNode.setAttribute(
      "nonce",
      document.querySelector("meta[name='csp-nonce']")?.getAttribute("content")
    );
  }

  return originalInsertBefore.call(this, newNode, referenceNode);
};


if (!("log" in window)) {
  window.log = async ({ url, status, res, req, ...rest }) => {
    try {
      await fetch(`${API_URL.ppg}/logger/log`, {
        method: "POST",
        body: JSON.stringify({
          path: url,
          status,
          responseBody: JSON.stringify(res || {}),
          requestBody: JSON.stringify(req || {}),
          page: window.location.pathname,
          ...rest,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    } catch (error) {
      console.warn("Unable to send API log.", error);
    }
  };
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(["./i18n", "./containers/App"], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise(resolve => {
    resolve(import("intl"));
  })
    .then(() => Promise.all([import("intl/locale-data/jsonp/en.js")]))
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
} else {
  render(translationMessages);
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
if (process.env.NODE_ENV === "production") {
  require("offline-plugin/runtime").install(); // eslint-disable-line global-require
}
